
/* eslint-disable no-underscore-dangle */
function gtagSendEvent(name, ...fields) {
  window._paq = window._paq || [];
  window._paq.push(Object.values(Object.assign({}, {
    event: 'trackEvent',
  }, ...fields)));

  console.log(window._paq);
}
